import React from 'react';
import { CheckCircle2Icon, LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { MOCKUP_IMAGE } from '../data/brand';
const chips = ['50 ćwiczeń', '16 tygodni', '3 poziomy', '5 bonusów', 'PDF do druku'];
const assurances = [{
  icon: LockIcon,
  label: 'Bezpieczna płatność'
}, {
  icon: ZapIcon,
  label: 'Natychmiastowy dostęp'
}, {
  icon: ShieldCheckIcon,
  label: '10 dni gwarancji'
}];
export function Hero() {
  return <header id="top" className="bg-ink" data-id="element-79" data-mp="xae6qyecaek8">
      <div className="mx-auto grid max-w-shell gap-x-12 px-5 pb-14 pt-8 sm:px-6 sm:pt-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:pb-20 lg:pt-16" data-id="element-80" data-mp="xbfi73z9p32h">
        <div className="lg:col-start-1" data-id="element-81" data-mp="nc87kojx3mj2">
          <p className="inline-flex items-center gap-2 rounded-full border border-gold/60 bg-gold/10 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-gold sm:text-xs" data-id="element-82" data-mp="nb6njukxbpp7">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden="true" data-id="element-83" data-mp="3825w6klg5xiq" />
            System dla nauczycieli gitary jazzowej
          </p>
          <h1 className="mt-5 font-display text-[2.75rem] font-extrabold leading-[0.92] text-white sm:text-7xl" data-id="element-84" data-mp="3j6g1bysfzti2">
            Cały semestr gitary jazzowej <span className="text-gold" data-id="element-85" data-mp="39b4ip5dwy251">gotowy do uczenia.</span>
          </h1>
        </div>

        <div className="mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0 lg:self-center" data-id="element-86" data-mp="3e8wismopoukb">
          <img src={MOCKUP_IMAGE} alt="Arsenał Nauczyciela Jazzu: 50 ćwiczeń, 5 bonusów i materiały na komputerze, tablecie i telefonie" className="w-full" data-id="element-87" data-mp="30hhohjpct6xy" />
          <p className="mx-auto mt-3 w-fit border border-btn-shadow bg-forest px-4 py-2 text-center text-[10px] font-bold uppercase tracking-[0.16em] text-gold sm:text-xs" data-id="element-88" data-mp="2qkmrj58qbels">
            Twój semestr, gotowy do uczenia
          </p>
        </div>

        <div className="mt-8 lg:col-start-1 lg:mt-6" data-id="element-89" data-mp="2hjymv1586qlk">
          <p className="max-w-xl text-base leading-relaxed text-copy-light sm:text-lg" data-id="element-90" data-mp="2ll0eavswhycz">
            Arsenał Nauczyciela Jazzu™ to kompletny pakiet: plan semestru na 16 tygodni, 50
            gotowych ćwiczeń, teoria i 5 bonusów. Wchodzisz, patrzysz i uczysz.
          </p>
          <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2.5" data-id="element-91" data-mp="ic89fikzqczf">
            {chips.map(chip => <li key={chip} className="flex items-center gap-1.5 text-sm font-medium text-white" data-id="element-92" data-mp="ddf2ya44fm8r">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-93" data-mp="1b0nkju104b5h" />
                {chip}
              </li>)}
          </ul>
          <div className="mt-8" data-id="element-94" data-mp="162lyd08a3vps">
            <CtaButton fullWidth data-id="element-95" data-mp="112g3zcamjv40">Zobacz ofertę</CtaButton>
          </div>
          <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2" data-id="element-96" data-mp="114svoh66pju9">
            {assurances.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-xs text-copy-soft sm:text-sm" data-id="element-97" data-mp="3lsp1j88sy9bs">
                <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-98" data-mp="3hrlk4hb3w58g" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </header>;
}